module.exports = __webpack_public_path__ + "img/icon-16-up.76ea7d61.svg";